<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/SupplierMasterTableview"></BacktoPage>
          <Headerlayout :headertext="EditID
            ? $t('Supppliers.SupppliersMaster.EditFormHeader')
            : $t('Supppliers.SupppliersMaster.FormHeader')
            " :contenttext="$t('Supppliers.SupppliersMaster.FormHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="form-white-bg my-3">
        <b-form class="" @submit.prevent="submitForm">
          <b-row><b-col>
              <h6 class="compo-heading mb-1">
                {{ $t("5005.SupplierInfoandUploadimages") }}
              </h6>
            </b-col></b-row>
          <div class="details-card">
            <b-row>
              <b-col lg="6" md="6" sm="12" cols="12">
                <b-row>
                  <b-col lg="6" md="12" sm="8" cols="12">
                    <div class="field">
                      <TextInput id="ID" name="ID" :label="$t('5005.id')" :rules="{ required: true }" :disabled="true"
                        placeholder="" v-model="SupformData.Code" :required-icon="true" />
                    </div>
                  </b-col>
                  <!-- </b-row>
                  <b-row> -->
                  <b-col lg="6" md="12" sm="8" cols="12">
                    <div class="field">
                      <TextInput id="Name" name="Name" :label="$t('5005.name')" :rules="{ required: true }"
                        placeholder="" v-model="SupformData.Name" :required-icon="true" case="Capital"
                        :autofocus="true" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" md="12" sm="8" cols="12">
                    <div class="field">
                      <CustomDropdown id="category" name="Supplier type" :label="$t('5005.type')"
                        :rules="{ required: false }" :items="supcategory" v-model="SupformData.SupplierCategory"
                        :required-icon="false" @change="SupplierCategory" />
                    </div>
                  </b-col>
                  <!-- </b-row>
                  <b-row> -->
                  <b-col lg="6" md="12" sm="8" cols="12">
                    <div class="field">
                      <MultiSelectDropDown v-model="multipleBranchId" :items="BranchData" ref="multiRef"
                        name="SupplierBranch" :label="$t('5000.Branch')" :rules="{ required: true }"
                        :required-icon="true" id="SupplierBranch" @update:modelValue="BranchOnChange" />
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col lg="6" md="12" sm="8" cols="12" v-if="StoreDropDown.StoreDropDownDisplay">
                    <div class="field">
                      <MultiSelectDropDown v-model="StoreDropDown.StoreBranchMapId" :items="StoreDropDown.Option"
                        @update:modelValue="" ref="multiRef" :name="$t('5000.store')" :label="$t('5000.store')"
                        :rules="{ required: false }" :required-icon="true" :id="$t('5000.store')" />
                    </div>
                  </b-col>
                  <!-- </b-row>
                  <b-row> -->
                  <b-col lg="6" md="12" sm="8" cols="12">
                    <div class="field" @mouseleave="handleMouseLeave">
                      <TextInput :id="$t('5005.emailid')" :name="$t('5005.emailid')" :label="$t('5005.emailid')"
                        :rules="{ required: true, email: true }" placeholder="" v-model="SupformData.Email"
                        :required-icon="true" case="Lower" autocomplete="off" :readonly="isReadonly"
                        @keyup="makeEditable()" @click="makeEditable()" />
                    </div>
                  </b-col>
                </b-row>

              </b-col>
              <b-col lg="5" md="6" sm="12" cols="12">
                <b-row>
                  <b-col>
                    <FileUpload uploadoption="imageupload" :imageData="imageData" @ImageURL="FileNameData"
                      :PorpsImageList="PorpsImageList" @deletedImageId="deletedImageId"></FileUpload>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="3" sm="8" cols="12">
                <div class="field">
                  <CustomTextarea name="Additional terms" :label="$t('5005.additionalterms')"
                    :rules="{ required: false }" id="Additional terms" v-model="SupformData.AdditionalTerms" />
                </div>
              </b-col>
              <b-col lg="3" md="3" sm="8" cols="12">
                <div class="field">
                  <CustomTextarea name="Reference" v-model="SupformData.Reference" :label="$t('5005.reference')"
                    :rules="{ required: false }" id="Ref terms" />
                </div>
              </b-col>
              <!-- <b-col lg="3" md="3" sm="8" cols="12">
                <div class="field" @mouseleave="handleMouseLeave">
                  <TextInput :id="$t('5005.emailid')" :name="$t('5005.emailid')" :label="$t('5005.emailid')"
                    :rules="{ required: true, email: true }" placeholder="" v-model="SupformData.Email"
                    :required-icon="true" case="Lower" autocomplete="off" :readonly="isReadonly" @keyup="makeEditable()"
                    @click="makeEditable()" />
                </div>
              </b-col> -->
            </b-row>
          </div>
          <b-row class="py-3">
            <b-col lg="6" md="6" sm="12" cols="12">
              <AddressDetails v-model="objaddressdetails" :Id="SupformData.Id" />
              <div class="mt-4">
                <BankInformation v-model="objdatabankdetails" />
              </div>
            </b-col>

            <b-col lg="6" md="6" sm="12" cols="12">
              <div class="pt-5 pe-5 d-flex justify-content-between">
                <h6 class="compo-heading">
                  {{ $t("5005.contactdetails.contactdetails") }}
                </h6>
                <p class="blue-txt" @click="isCreate()">
                  {{ $t("btn.addnew") }}
                </p>
              </div>
              <b-row>
                <b-col xl="12" lg="12" v-for="(items, index) in contactlist" :key="index">
                  <div>
                    <div class="contactCard">
                      <div class="m-3">
                        <div class="d-flex align-items-center">
                          <span class="light-txt me-4">{{ $t("5005.contactdetails.contactdetails") }}
                            {{ index + 1 }}</span>
                          <div class="d-flex ms-auto">
                            <div class="blue-txt me-3">
                              <i class="pi pi-pencil" @click="isEditdetails(items, index + 1)"></i>
                            </div>
                            <div class="delete">
                              <i class="pi pi-trash trash" @click="contactRemoveTagging(items)"></i>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex my-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.name") }} :
                          </span>
                          <p class="n-txt">{{ items.ContactPerson }}</p>
                        </div>

                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.designation") }} :
                          </span>
                          <p class="n-txt">{{ items.ContactDesignation }}</p>
                        </div>
                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.phone") }} :
                          </span>
                          <p class="n-txt">{{ items.Phone }}</p>
                        </div>
                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.laneLinenumber") }} :
                          </span>
                          <p class="n-txt">{{ items.LaneLine }}</p>
                        </div>
                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.email") }} :
                          </span>
                          <p class="n-txt">{{ items.Email }}</p>
                        </div>
                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.fax") }} :
                          </span>
                          <p class="n-txt">{{ items.Fax }}</p>
                        </div>
                        <div class="d-flex mb-2 align-items-center">
                          <span class="light-txt fn12 me-4">{{ $t("5005.contactdetails.website") }} :
                          </span>
                          <p class="n-txt">{{ items.Web }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div class="mt-3">
                <Tax v-model="objtaxdatadetails" />
              </div>
              <div class="details-card">
                <b-row>
                  <b-col class="addcircle_field">
                    <div class="field">
                      <CustomDropdown id="paymentterms" name="paymentterms" :label="$t('5005.paymentterms.terms')"
                        :items="paymenttermsdd" v-model="objdatapaymentsterms.PayTermsId" />
                      <!-- <span
                        class="float-end blue-txt mt-3"
                        @click="
                          FunctionRights(EntityIds.PaymentTerms, 'PaymentTerms')
                        "
                        >+Add Payment Terms</span
                      > -->
                    </div>
                    <span class="add_circle" @click="
                      FunctionRights(EntityIds.PaymentTerms, 'PaymentTerms')
                      "><i class="pi pi-plus"></i></span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="addcircle_field">
                    <div class="field">
                      <CustomDropdown id="DeliveryTerms" name="DeliveryTerms" :label="$t('5005.DeliveryTerms')"
                        :items="OptionDeliveryTerms" v-model="SupformData.DeliveryTermsId" />
                      <!-- <span
                        class="float-end blue-txt mt-3"
                        @click="
                          FunctionRights(
                            EntityIds.DeliveryTerms,
                            'DeliveryTerms'
                          )
                        "
                        >+Add Delivery Terms</span
                      > -->
                    </div>
                    <span class="add_circle" @click="
                      FunctionRights(EntityIds.DeliveryTerms, 'DeliveryTerms')
                      "><i class="pi pi-plus"></i></span>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <div class="d-flex flex-row-reverse mt-5">
              <Footer @cancel="$router.back(), IsClear()" :cancelhide="false" :label="label" :loading="Saveloading" />
              <IsCreateSuccessully />
            </div>
          </b-row>
        </b-form>
      </b-row>
    </b-container>
  </div>
  <contactDetailsMappingPopup v-model:trigger="StatusVisible" v-if="StatusVisible" @update:modelValue="ContactDetails"
    v-model:selected-item="editItems" @close="StatusVisible = false" />
  <createdsuccessfully :visible="visible" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <PaymentCreation v-model:trigger="DialogShow.PaymentTerms" v-if="DialogShow.PaymentTerms"
    @load="PaymentTermsServicedd(), (DialogShow.PaymentTerms = false)" @close="DialogShow.PaymentTerms = false"
    :OperationID="ObjOperationId" :EntityId="EntityIds.PaymentTerms" />
  <DeliveryTermsCreation v-model:trigger="DialogShow.DeliveryTerms" v-if="DialogShow.DeliveryTerms"
    @load="LoadDeliveryTerms(), (DialogShow.DeliveryTerms = false)" @close="DialogShow.DeliveryTerms = false"
    :OperationID="ObjOperationId" :EntityId="EntityIds.DeliveryTerms" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, watch } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../components/GeneralButtons/SaveButton.vue";
import AddressDetails from "../../../../../../modules/Inventory/components/MasterCreation/AddressDetails.vue";
import ContactDetails from "../../../../../../modules/Inventory/components/MastersforInventory/contactdetails.vue";
import Tax from "../../../../../../modules/Inventory/components/MasterCreation/Tax.vue";
import PaymentTerms from "../../../../../../modules/Inventory/components/MasterCreation/PaymentTerms.vue";
import BankInformation from "../../../../../../modules/Inventory/components/MasterCreation/BankInformation.vue";
import FileUpload from "../../../../../../modules/Inventory/components/MasterCreation/FileUpload.vue";
import service from "../../../../../../modules/Inventory/Service/SupplierMaster";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import { resolve } from "path";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import { clear } from "console";
import common from "../../../../../../modules/Inventory/Service/CommonService";
import DeliveryTermsService from "../../../../../../modules/Inventory/Service/DeliveryTermsService";
import OtherTermsService from "../../../../../../modules/Inventory/Service/OtherTermsService";
// import FileUpload from 'primevue/fileupload';
import cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import contactDetailsMappingPopup from "../../../../../../modules/Inventory/components/MasterCreation/contactDetailsMappingPopup.vue";
import SupplierContactDetailsService from "../../../../Service/SupplierContactDetailsService";
import CustomTextarea from "../../../../../../components/FormComponents/TextArea.vue";
import PaymentCreation from "../../../Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue";
import DeliveryTermsCreation from "../../../Masters/Supplier/DeliveryTerms/DeliveryTermscreation.vue";
import MastersService from "../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import commonservice from "../../../../../../modules/Inventory/Service/StoreService";
import SupplierBranchMapping from "../../../../../../modules/Inventory/Service/SupplierBranchMappingService";
import MultiSelectDropDown from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
  },
  components: {
    AlreadyExist,
    BacktoPage,
    Headerlayout,
    Cancel,
    Save,
    AddressDetails,
    ContactDetails,
    Tax,
    PaymentTerms,
    BankInformation,
    FileUpload,
    CustomDropdown,
    TextInput,
    Footer,
    createdsuccessfully,
    UpdatedSuccessfully,
    Loader,
    contactDetailsMappingPopup,
    CustomTextarea,
    PaymentCreation,
    DeliveryTermsCreation,
    MultiSelectDropDown,
  },

  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");
    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let PorpsImageList: any = ref([]);
    let ImageURLList: any = ref([]);
    const StatusVisible = ref(false);
    const isReadonly = ref(true);
    const iswrite = ref(false);

    const visible = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    const editItems = ref();

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    let Saveloading = ref(false);
    const routers = useRouter();
    const router = useRoute();
    const UpdateId = router.query;
    const model: any = ref(props.selectedItem);
    const EditID = router.query.Id;
    const OperationId: any = Number(router.query.OperationId);

    let supcategory = ref();
    let removecontact: any = ref([]);
    let contactlist: any = ref([]);
    let updateContact: any = ref([]);
    let createContact: any = ref([]);
    const successpop = ref(false);
    let isSubmitCalled = false;
    let paymenttermsdd = ref();
    let OptionDeliveryTerms = ref();
    let BranchData = ref([]);
    let selectedBranchId: any = [];

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );
    const insert_contactdetails = ref({
      Id: 0,
      SupplierId: 0,
      ContactPerson: "",
      ContactDesignation: "",
      Phone: "",
      Email: "",
      Web: "",
      LaneLine: "",
      Fax: "",
      index: 0,
    });

    const objcontactdetails = ref({
      ContactPerson: "",
      ContactDesignation: "",
      Phone: "",
      Email: "",
      Web: "",
    });

    const objdatabankdetails = ref({
      BankName: "",
      BankAcNo: "",
      ReBankAcNo: "",
      BankBranch: "",
      IFSC: "",
    });

    const objaddressdetails = ref({
      StreetName: "",
      Landmark: "",
      Address: "",
      City: 0,
      State: 0,
      Country: 0,
      Pin: "",
    });

    const objtaxdatadetails = ref({
      VATNo: "",
      ServiceTaxNo: "",
      ExciseCode: "",
      IncomeTaxNo: "",
      GST: "",
      MSME: "",
      RTGSCODE: "",
      DrugLicence: "",
      GSTNO: ""
    });

    const objdatapaymentsterms = ref({
      PayTermsId: 0,
      CreditPeriod: 0,
      DateOfAssociation: "",
      DiscountPer: 0,
    });

    function closetrigger() {
      visible.value = false;
      updatepop.value = false;
      //routers.back();
      setupHistoryManagement(routers, 2);
    }

    const SupformData = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      Id: 0,
      Code: "",
      Name: "",
      Tds: "",
      Note: "",
      HospitalId: 0,
      BranchId: 0,
      AccountNo: 0,
      Village: 0,
      SupplierCategory: ref(),
      DeliveryTermsId: 0,
      OtherTermsId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      AdditionalTerms: "",
      Reference: "",
      Email: "",
    });

    const SupplierBranchForm = ref({
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "",
      ModifiedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "string",
      EntityId: 0,
      EntityOperationId: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      SupplierId: 0,
    });

    let multipleBranchId: any = ref([]);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      PaymentTerms: false,
      DeliveryTerms: false,
    });
    let EntityIds = ref({
      PaymentTerms: 116,
      DeliveryTerms: 117,
    });
    onMounted(() => {
      document.addEventListener("keydown", onKeyUp);
      if (EditID != "" && EditID != null) {
        IsEdit();
      } else {
        GetCode();
      }
      suppliercategorydd();
      PaymentTermsServicedd();
      LoadDeliveryTerms();
      // LoadOtherTerms();
      LoadBranch();
    });

    async function LoadBranch() {
      debugger;
      let result = await commonservice.getBranch(session.OrganizationId);
      BranchData.value = result["result"]
        .map((item) => {
          item.name = item.Name;
          item.value = item.ID;
          return item;
        })
        .filter((items) => items.OrganizationId == HospitalId);
      debugger;
    }

    async function IsEdit() {
      try {
        debugger;
        label.value = "Update";
        let response = await service.EditData(EditID);
        const data1 = response["result"][0];

        Object.keys(SupformData.value).forEach((key) => {
          if (data1[key]) SupformData.value[key] = data1[key];
        });

        Object.keys(objaddressdetails.value).forEach((key) => {
          if (data1[key]) objaddressdetails.value[key] = data1[key];
        });

        Object.keys(objdatabankdetails.value).forEach((key) => {
          if (data1[key]) objdatabankdetails.value[key] = data1[key];
        });

        Object.keys(objcontactdetails.value).forEach((key) => {
          if (data1[key]) objcontactdetails.value[key] = data1[key];
        });

        Object.keys(objtaxdatadetails.value).forEach((key) => {
          if (data1[key]) objtaxdatadetails.value[key] = data1[key];
        });

        Object.keys(objdatapaymentsterms.value).forEach((key) => {
          if (key == "DateOfAssociation") {
            const regex = /^\d{2}-\d{2}-\d{4}$/;
            let dateOfAssociation: any;
            if (data1[key]) {
              dateOfAssociation = moment(data1[key]).format("DD-MM-YYYY");
            }
            data1[key] = dateOfAssociation;
          } else {
            if (data1[key]) objdatapaymentsterms.value[key] = data1[key];
          }
        });

        const contactdata_response = await SupplierContactDetailsService.Edit(
          EditID
        );
        contactlist.value = contactdata_response["result"];
        const ImgResponse = await service.GetFilesBySupplierId(EditID);
        for (let item of ImgResponse["result"]) {
          PorpsImageList.value.push(item);
        }

        const SupplierBranch = await SupplierBranchMapping.getById(EditID);
        for (let item of SupplierBranch["result"]) {
          multipleBranchId.value.push(item["BranchId"]);
          selectedBranchId.push(item);
        }

        if (response["result"][0].SupplierCategory == 3) {
          StoreDropDown.value.StoreDropDownDisplay = true;
          await LoadStore();
          const SupplierStoreBranch = await service.getSupplierStoreBySupplierId(EditID);
          for (let item of SupplierStoreBranch["result"]) {
            StoreDropDown.value.StoreBranchMapId.push(item["StoreBranchMapId"]);
            HiddenStoreBranchMapIds.push(item);
          }
        } else {
          StoreDropDown.value.StoreDropDownDisplay = false;
        }



      } catch (error) {
        console.log(error);
      }
    }

    async function PaymentTermsServicedd() {
      try {
        const dataresponse = await service.getpaymentstermsdd();

        console.log(dataresponse["result"]);

        paymenttermsdd.value = dataresponse["result"]
          .filter((items) => items.HospitalId == HospitalId)
          .map((item) => {
            item.name = item.PaymentTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Load Delivery Terms

    async function LoadDeliveryTerms() {
      try {
        const dataresponse = await DeliveryTermsService.getdata();

        console.log(dataresponse["result"]);

        OptionDeliveryTerms.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
          .map((item) => {
            item.name = item.DeliTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Load Other Terms
    let OptionOtherTerms = ref();

    async function LoadOtherTerms() {
      try {
        const dataresponse = await OtherTermsService.getdata();

        console.log(dataresponse["result"]);

        OptionOtherTerms.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
          .map((item) => {
            item.name = item.OtherTermDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    async function suppliercategorydd() {
      try {
        const dataresponse = await service.getdata();

        console.log(dataresponse);

        supcategory.value = dataresponse["result"].map((item: any) => {
          item.name = item.SupplierCatName;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    async function GetCode() {
      debugger;
      let data = {
        //FormId: 1021,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      SupformData.value.Code = result;
    }

    function isEditdetails(data, index) {
      try {
        data.index = index;
        editItems.value = data;

        // Editmodel.value = false;
        debugger;
        StatusVisible.value = true;
      } catch (error) {
        alert(error);
      }
    }

    function contactRemoveTagging(index) {
      const mention = contactlist.value.findIndex((item) => item === index);
      contactlist.value.splice(mention, 1);
      if (index["Id"] != 0) {
        const newObj = {
          id: index["Id"],
        };
        removecontact.value.push(newObj);
      }
    }

    function ContactDetails(data) {
      if (data.index == 0) {
        contactlist.value.push(data);
      } else {
        Object.assign(contactlist.value[data.index - 1], data);
      }
    }

    // submit function

    const submitForm = async () => {
      debugger;
      Saveloading.value = true;
      debugger;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }


      let checkcondition = true

      if (StoreDropDown.value.StoreBranchMapId.length == 0 && SupformData.value.SupplierCategory == 3) {
        toast.add({
          severity: "warn",
          summary: "Please select Store Branch!",
          detail: "A supplier of type 'Store Supplier' must be mapped to at least one store branch before saving.",
          life: 3000,
        });
        checkcondition = false
        Saveloading.value = false;
        return;
      }


      const response = await service.gettable();
      console.log(response["result"]);
      response["result"] = response["result"]
        .filter((items) => items.HospitalId == HospitalId && items.GSTNO == objtaxdatadetails.value.GSTNO && items.Id != (EditID || 0))
      if (response["result"].length > 0) {
        toast.add({
          severity: "warn",
          summary: "This GSTNO. is Already Used by another supplier!",
          detail: "",
          life: 3000,
        });
        checkcondition = false
        Saveloading.value = false;
        return;
      }

      if (checkcondition == true) {
        let contactResult: any;
        let contactResponse: any;
        let BranchResponse: any;
        let EmailId = SupformData.value.Email;
        let SupplierBranchobject: any = ref([]);
        SupformData.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        SupformData.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        SupformData.value.BranchId = BranchId;
        SupformData.value.HospitalId = HospitalId;
        SupformData.value.ModifiedBy = UserId;
        SupformData.value.CreatedBy = UserId;
        SupformData.value.EntityId = Number(Entitydata.value.EntityId);
        SupformData.value.EntityOperationId = OperationId;
        objdatapaymentsterms.value.PayTermsId =
          objdatapaymentsterms.value.PayTermsId == null
            ? 0
            : objdatapaymentsterms.value.PayTermsId;

        SupformData.value.DeliveryTermsId =
          SupformData.value.DeliveryTermsId == null
            ? 0
            : SupformData.value.DeliveryTermsId;
        SupplierBranchForm.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        SupplierBranchForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        SupplierBranchForm.value.ModifiedBy = UserId;
        SupplierBranchForm.value.CreatedBy = UserId;
        if (contactlist.length != 0) {
          contactResult = contactlist.value.map(({ index, ...rest }) => rest);
          contactResult.map((item) => {
            (item.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (item.CreatedBy = 0),
              (item.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (item.ModifiedBy = 0),
              (item.HospitalId = HospitalId),
              (item.BranchId = BranchId);
          });
        }

        if (multipleBranchId.value) {
          for (let item of multipleBranchId.value) {
            const newSupplierBranchForm = { ...SupplierBranchForm.value };
            newSupplierBranchForm.BranchId = item;
            SupplierBranchobject.value.push(newSupplierBranchForm);
          }
        }

        if (
          objdatabankdetails.value.BankAcNo == objdatabankdetails.value.ReBankAcNo
        ) {
          let dateOfAssociation = "";
          if (objdatapaymentsterms.value.DateOfAssociation) {
            dateOfAssociation = moment(
              objdatapaymentsterms.value.DateOfAssociation,
              "DD-MM-YYYY"
            ).format("YYYY-MM-DD");
          }

          objdatapaymentsterms.value.DateOfAssociation = dateOfAssociation;
          debugger;
          if (SupformData.value.Id != 0) {
            const data_insert = Object.assign(
              SupformData.value,
              objaddressdetails.value,
              objdatabankdetails.value,
              objtaxdatadetails.value,
              objdatapaymentsterms.value,
              objcontactdetails.value
            );
            data_insert.Email = EmailId;
            try {
              const data_response = await service.update(data_insert);

              if (DeletedImageIdArray.value.length > 0) {
                const DeletedImageResponse = await service.DeleteList(
                  DeletedImageIdArray.value.join(",")
                );
              }
              let message = data_response["ErrorInfo"].ErrorCode;
              for (let j = 0; j < contactResult.length; j++) {
                debugger;
                const element = contactResult[j];
                if (element.Id != 0) {
                  updateContact.value.push(element);
                } else {
                  createContact.value.push(element);
                }
              }
              if (updateContact.value.length != 0) {
                contactResponse = await SupplierContactDetailsService.Update(
                  updateContact.value
                );
                message = contactResponse["ErrorInfo"].ErrorCode;
              }
              if (createContact.value.length != 0) {
                createContact.value.map((item) => {
                  item.SupplierId = UpdateId.Id;
                });
                contactResponse = await SupplierContactDetailsService.insert(
                  createContact.value
                );
                message = contactResponse["ErrorInfo"].ErrorCode;
              }
              if (removecontact.value.length != 0) {
                for (let i = 0; i < removecontact.value.length; i++) {
                  if (!removecontact.value[i].IsActive) {
                    let result = await SupplierContactDetailsService.Delete(
                      removecontact.value[i].id
                    );
                  }
                }
              }

              debugger;
              if (data_response["result"] == "Already" && message == null) {
                Saveloading.value = false;
                alreadyexistpop.value = true;
              } else if (message == null) {

                if (SupplierBranchobject.value.length >= 1) {
                  SupplierBranchobject.value.map((item) => {
                    item.SupplierId = UpdateId.Id;
                  });

                  BranchResponse = await SupplierBranchMapping.insert(
                    SupplierBranchobject.value
                  );
                  message = BranchResponse["ErrorInfo"].ErrorCode;
                }

                let filteredBranchId = selectedBranchId.filter(
                  (item) => !multipleBranchId.value.includes(item["BranchId"])
                );

                for (let item of filteredBranchId) {
                  let result = await SupplierBranchMapping.delete(item["Id"]);
                }

                if (StoreDropDown.value.StoreBranchMapId.length > 0) {
                  let ListSupplierStore = await ListAssignSupplierStore(UpdateId.Id);

                  let resultSupplierStore = await service.CreateSupplierStore(
                    ListSupplierStore
                  );
                  message = resultSupplierStore["ErrorInfo"].ErrorCode;
                }

                let filteredStoreBranchMapIdList = HiddenStoreBranchMapIds.filter(
                  (item) => !StoreDropDown.value.StoreBranchMapId.includes(item["StoreBranchMapId"])
                );

                filteredStoreBranchMapIdList = filteredStoreBranchMapIdList.map((item) => {
                  item.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    item.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    item.ModifiedBy = UserId
                  return item;
                });

                let deletedresult = await service.deleteSupplierStore(filteredStoreBranchMapIdList);
                message = deletedresult["ErrorInfo"].ErrorCode;

                FileInsert(SupformData.value.Id);

                if (message == null) {
                  Saveloading.value = false;
                  updatepop.value = true;
                }
                else {
                  Saveloading.value = false;
                  alert("something went wrong");
                }

              } else {
                Saveloading.value = false;
                alert("something went wrong");
              }
              // IsClear();
            } catch (error) {
              Saveloading.value = false;
              console.log(error);
            }
          } else {
            const data_insert = Object.assign(
              SupformData.value,
              objaddressdetails.value,
              objdatabankdetails.value,
              objtaxdatadetails.value,
              objdatapaymentsterms.value,
              objcontactdetails.value
            );
            debugger;
            data_insert.Email = EmailId;
            try {
              const data_response = await service.insert(data_insert);
              console.log(data_response);
              let SupplierId = data_response["result"];
              let message = data_response["ErrorInfo"].ErrorCode;
              let SupId = data_response["result"];
              if (contactResult.length != 0) {
                contactResult.map((item) => {
                  item.SupplierId = SupplierId;
                });
                contactResponse = await SupplierContactDetailsService.insert(
                  contactResult
                );
                message = contactResponse["ErrorInfo"].ErrorCode;
              }

              if (data_response["result"] == "Already" && message == null) {
                Saveloading.value = false;
                alreadyexistpop.value = true;
              } else if (message == null) {

                if (SupplierBranchobject.value.length >= 1) {
                  SupplierBranchobject.value.map((item) => {
                    item.SupplierId = SupplierId;
                  });
                  BranchResponse = await SupplierBranchMapping.insert(
                    SupplierBranchobject.value
                  );
                  message = BranchResponse["ErrorInfo"].ErrorCode;
                }

                if (StoreDropDown.value.StoreBranchMapId.length > 0) {
                  let ListSupplierStore = await ListAssignSupplierStore(SupplierId);

                  let resultSupplierStore = await service.CreateSupplierStore(
                    ListSupplierStore
                  );
                  message = resultSupplierStore["ErrorInfo"].ErrorCode;
                }

                FileInsert(SupId);

                if (message == null) {
                  visible.value = true;
                  Saveloading.value = false;
                }
                else {
                  Saveloading.value = false;
                  alert("something went wrong");
                }
              } else {
                Saveloading.value = false;
                alert("something went wrong");
              }
            } catch (error) {
              Saveloading.value = false;
              console.log(error);
            }
          }
        }


      } else {
        console.log("check bank account number condition");
      }
    };

    function FileNameData(data) {
      debugger;
      ImageURLList.value = data;
      console.log(ImageURLList);
    }

    const ImgObj = ref({
      CreatedAt: "2023-02-03T11:57:55.028Z",
      ModifiedAt: "2023-02-03T11:57:55.028Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      Id: 0,
      SupplierId: 0,
      ImageFile: "",
    });

    async function FileInsert(SupplierId) {
      debugger;
      for (let item of ImageURLList.value) {
        if (!item["Id"]) {
          let Formdata = {
            CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            CreatedBy: UserId,
            ModifiedBy: 0,
            ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            HospitalId: HospitalId,
            BranchId: BranchId,
            Id: 0,
            EntityId: Number(Entitydata.value.EntityId),
            EntityOperationId: OperationId,
            SupplierId: SupplierId,
            ImageFile: item["ImageFile"].split("/FileUpload/")[1],
          };
          const data_response = await service.Fileinsert(Formdata);
          let msg = data_response["ErrorInfo"].ErrorCode;
        }
      }
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      SupformData.value.Name = "";
      //showDialog.value = true
    }

    const copydataModel1 = JSON.parse(JSON.stringify(SupformData.value));
    const copydataModel2 = JSON.parse(JSON.stringify(objaddressdetails.value));
    const copydataModel3 = JSON.parse(JSON.stringify(objdatabankdetails.value));
    const copydataModel4 = JSON.parse(JSON.stringify(objtaxdatadetails.value));

    const copydataModel5 = JSON.parse(
      JSON.stringify(objdatapaymentsterms.value)
    );

    const copydataModel6 = JSON.parse(JSON.stringify(objcontactdetails.value));
    const copyinsert_contactdetails = JSON.parse(
      JSON.stringify(insert_contactdetails.value)
    );

    const IsClear = () => {
      Object.assign(SupformData.value, copydataModel1);
      Object.assign(objaddressdetails.value, copydataModel2);
      Object.assign(objdatabankdetails.value, copydataModel3);
      Object.assign(objtaxdatadetails.value, copydataModel4);
      Object.assign(objdatapaymentsterms.value, copydataModel5);
      Object.assign(objcontactdetails.value, copydataModel6);
      Object.assign(insert_contactdetails.value, copyinsert_contactdetails);

      emit("update:selectedItem", undefined);
      emit("close");
    };

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          submitForm();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    const isCreate = () => {
      StatusVisible.value = true;
    };

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    let DeletedImageIdArray = ref([]);
    function deletedImageId(value) {
      DeletedImageIdArray.value = value;
    }

    function makeEditable() {
      debugger;

      if (SupformData.value.Email.length == 0 && iswrite.value == true) {
        isReadonly.value = true;
        iswrite.value = false;
      } else {
        isReadonly.value = false;
        iswrite.value = true;
      }
    }
    const handleMouseLeave = () => {
      isReadonly.value = true; // Set readonly to true on mouse leave
    };

    // Supplier Store mapping
    let HiddenStoreBranchMapIds: any = [];
    let StoreDropDown: any = ref(
      {
        StoreDropDownDisplay: false,
        Option: [],
        StoreBranchMapId: [],
        BranchId: 0
      }
    );

    function SupplierCategory() {
      debugger;
      if (multipleBranchId.value.length > 0 && SupformData.value.SupplierCategory == 3 && (SupformData.value.SupplierCategory != null || SupformData.value.SupplierCategory != undefined)) {
        StoreDropDown.value.StoreDropDownDisplay = true;
        StoreDropDown.value.StoreBranchMapId = [];
        StoreDropDown.value.Option = [];
        LoadStore();
      }
      else {
        StoreDropDown.value.StoreDropDownDisplay = false;
        StoreDropDown.value.StoreBranchMapId = [];
        StoreDropDown.value.Option = [];
      }
    }

    function BranchOnChange() {
      debugger;
      if (multipleBranchId.value.length > 0 && SupformData.value.SupplierCategory == 3 && (SupformData.value.SupplierCategory != null || SupformData.value.SupplierCategory != undefined)) {
        StoreDropDown.value.StoreDropDownDisplay = true;
        StoreDropDown.value.StoreBranchMapId = [];
        StoreDropDown.value.Option = [];
        LoadStore();
      }
    }

    async function LoadStore() {
      debugger;
      try {
        let result = await commonservice.getStoreList(
          HospitalId,
          multipleBranchId.value
        );

        StoreDropDown.value.Option = result["result"].filter((x) => x.StoreTypeId == 1 && x.IsStoreSupplier == true).map((item) => {
          item.name = item.StoreName;
          item.value = item.StoreBranchMapId;
          return item;
        });

      } catch (error) {
        console.log(error);
      }
    }

    function ListAssignSupplierStore(SupplierId) {
      debugger;
      let arr: any = [];

      for (let i = 0; i < StoreDropDown.value.StoreBranchMapId.length; i++) {

        let StoreBranchMapId = StoreDropDown.value.StoreBranchMapId[i];

        let storeObj = StoreDropDown.value.Option.find(
          (item) => item.value === StoreBranchMapId
        );

        let obj: any = {};

        obj["CreatedBy"] = UserId;
        obj["ModifiedBy"] = UserId;
        obj["Id"] = 0;
        obj["SupplierId"] = SupplierId;
        obj["StoreId"] = storeObj ? storeObj.Id : 0;
        obj["StoreBranchId"] = storeObj ? storeObj.BranchId : 0;
        obj["StoreBranchMapId"] = StoreBranchMapId || 0;

        arr[i] = obj;
      }

      return arr;
    }

    return {
      handleMouseLeave,
      makeEditable,
      isReadonly,
      EditID,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
      isCreate,
      ContactDetails,
      editItems,
      StatusVisible,
      alreadyclosetrigger,
      alreadyexistpop,
      suppliercategorydd,
      SupformData,
      objaddressdetails,
      objdatabankdetails,
      objtaxdatadetails,
      paymenttermsdd,
      objdatapaymentsterms,
      objcontactdetails,
      submitForm,
      supcategory,
      Saveloading,
      visible,
      updatepop,
      closetrigger,
      IsEdit,
      IsClear,
      LoadDeliveryTerms,
      LoadOtherTerms,
      OptionDeliveryTerms,
      OptionOtherTerms,

      isEditdetails,
      contactRemoveTagging,
      label,
      FileNameData,
      PaymentTermsServicedd,
      PorpsImageList,
      contactlist,
      BranchData,
      multipleBranchId,
      deletedImageId,
      SupplierCategory,
      BranchOnChange,
      StoreDropDown,
      imageData: {
        src: "",
        alt: "example image",
      },
    };
  },
});
</script>
